import script from "./FormData.vue?vue&type=script&setup=true&lang=js"
export * from "./FormData.vue?vue&type=script&setup=true&lang=js"

import "./FormData.vue?vue&type=style&index=0&id=392d63dc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-392d63dc"]])

export default __exports__